var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bubbles"},_vm._l((_vm.count),function(i){return _c('div',{key:`bubble-${i}`,staticClass:"bubble",style:(_vm.styles[i])})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }